var _defs, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureMobileEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a29",
    x1: 9,
    y1: 22.81,
    x2: 9,
    y2: -2.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#1c84dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    stopColor: "#3990e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d99ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#5a9eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b29",
    x1: 9,
    y1: 15.982,
    x2: 9,
    y2: 1.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#f0fffd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.612,
    width: 10.777,
    height: 18,
    rx: 0.419,
    fill: "url(#a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.758,
    y: 0.604,
    width: 2.483,
    height: 0.333,
    rx: 0.154,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.623,
    y: 1.522,
    width: 8.754,
    height: 14.461,
    rx: 0.201,
    opacity: 0.9,
    fill: "url(#b)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.398,
    y: 16.58,
    width: 1.204,
    height: 1.028,
    rx: 0.286,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 2.892v3.584a.192.192 0 01-.193.192h-1.5a.047.047 0 00-.047.047v.578a.094.094 0 01-.151.074l-.9-.689a.048.048 0 00-.029-.01H5.974a.192.192 0 01-.193-.192V2.892a.192.192 0 01.193-.192h5.236a.192.192 0 01.19.192z",
    fill: "#5ea0ef"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.768,
    y: 9.88,
    width: 1.683,
    height: 4.782,
    rx: 0.293,
    fill: "#5ea0ef"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.265,
    y: 8.806,
    width: 1.683,
    height: 5.855,
    rx: 0.293,
    fill: "#0078d4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.761,
    y: 7.927,
    width: 1.683,
    height: 6.734,
    rx: 0.293,
    fill: "#005ba1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureMobileEngagement);
export default __webpack_public_path__ + "static/media/azure-mobileEngagement.6052fe46e204033ee00e118216fc9e6d.svg";
export { ForwardRef as ReactComponent };